import {ApplicationConfig, LOCALE_ID, importProvidersFrom, provideAppInitializer, inject} from '@angular/core';
import { provideRouter } from '@angular/router';
import { provideAnimations } from '@angular/platform-browser/animations';
import { provideHttpClient, withInterceptors } from '@angular/common/http';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { routes } from './app.routes';
import { authInterceptor } from './services/auth.interceptor';
import { recaptchaInterceptor } from './services/recaptcha.interceptor';
import {AppConfigService} from "@app/app-config.service";

export const appConfig: ApplicationConfig = {
  providers: [
    provideRouter(routes),
    provideAnimations(),
    provideHttpClient(withInterceptors([recaptchaInterceptor, authInterceptor])),
    importProvidersFrom(FormsModule, ReactiveFormsModule),
    { provide: LOCALE_ID, useValue: 'de' },

    // ✅ NEU: Runtime-Config vor App-Start laden
    provideAppInitializer(() => inject(AppConfigService).load())
  ]
};
